import React from 'react';

import * as S from './styled';

const Title = props => <S.Title>{ props.text }</S.Title>;

export default Title;